module.exports = __webpack_public_path__ + "static/media/trial3_4.3d254982.png";